import type {
  MultipleAvailableOpportunity,
  MultipleOpportunity,
  SingleAvailableOpportunity,
  SingleOpportunity
} from '@ps/web-sports-api-types';

type Opportunity = SingleOpportunity | MultipleOpportunity;

export const getIsSingleOpportunity = (
  opportunity: Opportunity
): opportunity is SingleOpportunity => opportunity.type === 'SINGLE';

export const getIsAvailableOpportunity = (
  opportunity: Opportunity
): opportunity is SingleAvailableOpportunity | MultipleAvailableOpportunity =>
  opportunity.status === 'AVAILABLE';

export const getIsSingleAvailableOpportunity = (
  opportunity: Opportunity
): opportunity is SingleAvailableOpportunity =>
  getIsSingleOpportunity(opportunity) && getIsAvailableOpportunity(opportunity);
